import { render, staticRenderFns } from "./CommentElementSettings.vue?vue&type=template&id=ae2d3138&scoped=true&"
import script from "./CommentElementSettings.vue?vue&type=script&lang=ts&"
export * from "./CommentElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2d3138",
  null
  
)

export default component.exports